import { useSelector } from 'react-redux';
var useSelectors = function () {
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responsePerson: (_a = state.Person.responsePerson) === null || _a === void 0 ? void 0 : _a.data,
            errorPerson: state.Person.errorPerson,
            loadingPerson: state.Person.loadingPerson,
        });
    }), responsePerson = _a.responsePerson, errorPerson = _a.errorPerson, loadingPerson = _a.loadingPerson;
    return {
        responsePerson: responsePerson,
        errorPerson: errorPerson,
        loadingPerson: loadingPerson
    };
};
export default useSelectors;
